var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertWarningRedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 17,
    r: 12,
    fill: "#ac1d00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1562 18.7373H11.0117L10.5635 10.1504H13.6045L13.1562 18.7373ZM10.5283 21.7432C10.5283 21.251 10.6602 20.8789 10.9238 20.627C11.1875 20.375 11.5713 20.249 12.0752 20.249C12.5615 20.249 12.9365 20.3779 13.2002 20.6357C13.4697 20.8936 13.6045 21.2627 13.6045 21.7432C13.6045 22.2061 13.4697 22.5723 13.2002 22.8418C12.9307 23.1055 12.5557 23.2373 12.0752 23.2373C11.583 23.2373 11.2021 23.1084 10.9326 22.8506C10.6631 22.5869 10.5283 22.2178 10.5283 21.7432Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertWarningRedIcon);
export default __webpack_public_path__ + "static/media/alert-warning-red-icon.0789539982ba4d5833db45f45b594d85.svg";
export { ForwardRef as ReactComponent };